<template>
  <modal
    class="regulation-modal"
    name="regulation-modal"
    @before-open="beforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="50%"
    height="auto"
  >
    <div id="modal-header">
      <div class="w-75 d-flex">
        <p>Ներքին կանոնակարգ և փաստաթղթերի շաբլոններ</p>
      </div>
      <button type="button"
            class="close position-absolute"
            style="right: 1.25rem; top: 25%"
            @click="$modal.hide('regulation-modal')"
            aria-label="Close"
      >
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
        </svg>
      </button>
    </div>
    <div id="modal-body" style="padding: 20px;">
      <template v-if="loading">
        <div class="d-flex align-items-center justify-content-center" style="height: 200px">
          <div class="text-primary spinner-border spinner-border-lg" role="status"></div>
        </div>
      </template>
      <template v-else-if="!enabled">
        <p class="text-center">
          Ներքին կանոնակարգի գործառույթը միացված չէ Ձեր կազմակերպության համար։ Դիմեք iTender-ի ադմինիստրատորին։
        </p>
      </template>
      <template v-else>
        <div v-for="doc in documentTypes" :key="doc.type" class="regulation-doc-row row align-items-center mb-3">
          <div class="col-6">
            {{ doc.label }}
          </div>
          <div class="col-6 d-flex align-items-center justify-content-end">
            <a v-if="documents[doc.type]" :href="documents[doc.type]" target="_blank" class="btn btn-light mr-2">
              <span>Դիտել</span>
            </a>
            <button
              v-if="documents[doc.type]"
              type="button"
              class="btn btn-light mr-2"
              :disabled="uploadingType === doc.type"
              @click="remove(doc.type)"
            >
              <span>Ջնջել</span>
            </button>
            <label class="btn btn-primary mb-0" :class="{ disabled: uploadingType === doc.type }">
              <span v-if="uploadingType === doc.type" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              <span>{{ documents[doc.type] ? 'Փոխարինել' : 'Վերբեռնել' }}</span>
              <input
                type="file"
                style="display: none"
                accept=".pdf,.doc,.docx,.zip,.rar"
                :disabled="uploadingType === doc.type"
                @change="(event) => upload(doc.type, event)"
              >
            </label>
          </div>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'RegulationModal',
  data() {
    return {
      loading: true,
      enabled: false,
      uploadingType: null,
      documents: {
        regulation: null,
        contract_goods: null,
        contract_work: null,
        contract_service: null,
        invitation: null,
        application: null,
        report: null,
      },
      documentTypes: [
        { type: 'regulation', label: 'Ներքին կանոնակարգ' },
        { type: 'contract_goods', label: 'Պայմանագրի շաբլոն (ապրանք)' },
        { type: 'contract_work', label: 'Պայմանագրի շաբլոն (աշխատանք)' },
        { type: 'contract_service', label: 'Պայմանագրի շաբլոն (ծառայություն)' },
        { type: 'invitation', label: 'Հրավերի շաբլոն' },
        { type: 'application', label: 'Մասնակցի հայտի շաբլոն' },
        { type: 'report', label: 'Հաշվետվության ձև' },
      ],
    }
  },
  methods: {
    beforeOpen() {
      this.loading = true
      this.$client.get('organisation/regulation').then(({ data }) => {
        this.enabled = data.data.enabled
        this.documents = data.data.documents
        this.loading = false
      })
    },
    upload(type, event) {
      const file = event.target.files[0]
      if (!file) {
        return
      }
      this.uploadingType = type
      const formData = new FormData()
      formData.append('type', type)
      formData.append('file', file)
      this.$client.post('organisation/regulation/upload', formData).then(({ data }) => {
        this.documents = { ...this.documents, [type]: data.data.url }
        this.uploadingType = null
      }).catch(() => {
        this.uploadingType = null
      })
      event.target.value = ''
    },
    remove(type) {
      this.uploadingType = type
      this.$client.delete(`organisation/regulation/${type}`).then(() => {
        this.documents = { ...this.documents, [type]: null }
        this.uploadingType = null
      }).catch(() => {
        this.uploadingType = null
      })
    },
  },
}
</script>

<style scoped>
.regulation-doc-row:not(:last-child) {
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
}
</style>
